module.exports = __webpack_public_path__ + "media/1.1ce27fba.mp3";